<template>
  <CModal alignment="center" :visible="show" @close="$emit('close')">
    <CModalHeader class="bg-primary">
      <CModalTitle class="text-light fs-6">提示</CModalTitle>
    </CModalHeader>
    <CModalBody>
      {{ errorMsg }}
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" @click="submit">{{confirmText}}</CButton>
    </CModalFooter>
  </CModal>
</template>
<script>
import router from '@/router'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    errorMsg: {
      type: String,
      default: '',
    },
    errorCode: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    confirmText:{
      type: String,
      default: '確定',
    }
  },
  emits: ['close'],
  setup(props, { emit }) {
    const submit = () => {
      if (props.errorCode === 10002) {
        router.push('/sign')
      }
      if (props.errorCode === 'noFill') {
        router.push('/analysis-questionnaire')
      }

      if (props.errorCode === 'publishSuccess') {
        router.push('/analysis-questionnaire')
      }
      if (props.errorCode === 'userStateSuccess') {
        router.push('/user-management/user-reply')
      }
      emit('close')
    }
    return { submit }
  },
}
</script>
<style lang="scss" scoped>
img {
  width: 15px;
  margin: 0 10px;
}
.content {
  background-color: #fff;
  border: 1px solid #bdbdbd;
  outline: none;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.options-box {
  height: 300px;
  overflow: scroll;
}
</style>
